import { Card, Tab, Tabs } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import DoctorDiagnostico from "../doctor/DoctorDiagnostico";
import DoctorDiagnosticoColombia from "../doctor/DoctorDiagnosticoColombia";
import DoctorEstudioImagenColombia from "../doctor/DoctorEstudioImagenColombia";
import DoctorIncapacidadColombia from "../doctor/DoctorIncapacidadColombia";
import DoctorLaboratorioColombia from "../doctor/DoctorLaboratorioColombia";
import DoctorReceta from "../doctor/DoctorReceta";
import DoctorRecomendacionMedicaColombia from "../doctor/DoctorRecomendacionMedicaColombia";
import DoctorRemisionesColombia from "../doctor/DoctorRemisionesColombia";

function DetalleCitaAnexos2({t, cita, auth, companyType}){

    return (
        <Card className="shadow-1">
            <Card.Body>
                {
                    companyType === "colombia" ? 
                        <Tabs defaultActiveKey="receta" className="tabs-conference" transition={false}>
                            <Tab eventKey="receta" title={t('receta')}>
                                <DoctorReceta 
                                    appointmentReceta={cita?.receta}
                                    citaID={cita.id}
                                    auth={auth}
                                    readOnly={true}
                                />
                            </Tab>
                            <Tab eventKey="diagnostico" title={t('diagnostico')}>
                                <DoctorDiagnosticoColombia
                                    citaID={cita.id}
                                    auth={ auth } 
                                    disease={ cita?.diseaseList }
                                    idSpeciality={cita?.idSpeciality}
                                    readOnly={true}
                                    setValidDiagnostico={()=>{}}
                                />
                            </Tab>
                            <Tab eventKey="incapacidad" title={t('incapacidad')}>
                                <DoctorIncapacidadColombia 
                                    citaID={cita.id}
                                    auth={ auth } 
                                    incapacidad={ cita?.disability }
                                    readOnly={true}
                                />
                            </Tab>
                            <Tab eventKey="medicalRecomendacion" title={t('recomendacion_medica')}>
                                <DoctorRecomendacionMedicaColombia 
                                    citaID={cita.id}
                                    auth={ auth } 
                                    medicalRecommendation={ cita?.medicalRecommendation }
                                    readOnly={true}
                                />
                            </Tab>
                            <Tab eventKey="remisiones" title={t('remisiones')}>
                                <DoctorRemisionesColombia 
                                    citaID={cita.id}
                                    auth={ auth } 
                                    remisiones={ cita?.ordenRemisiones }
                                    readOnly={true}
                                />
                            </Tab>
                            <Tab eventKey="estudio" title={t('estudios_imagenologicos')}>
                                <DoctorEstudioImagenColombia 
                                    citaID={cita.id}
                                    auth={ auth } 
                                    estudiosImagenelogicos={ cita?.estudioImagenologicos }
                                    readOnly={true}
                                />
                            </Tab>
                            <Tab eventKey="laboratorios" title={t('laboratorios')}>
                                <DoctorLaboratorioColombia 
                                    citaID={cita.id}
                                    auth={ auth } 
                                    ordenLaboratorios={ cita?.ordenLaboratorios }
                                    readOnly={true}
                                />
                            </Tab>
                        </Tabs> :
                        <Tabs defaultActiveKey="receta" className="tabs-conference" transition={false}>
                        <Tab eventKey="receta" title={t('receta')}>
                            <DoctorReceta 
                                appointmentReceta={cita?.receta}
                                citaID={cita.id}
                                auth={auth} 
                                readOnly={true}
                            />
                        </Tab>
                        <Tab eventKey="diagnostico" title={t('diagnostico')}>
                            <DoctorDiagnostico 
                                citaID={cita.id}
                                auth={ auth } 
                                disease={ cita?.disease }
                                idSpeciality={cita?.idSpeciality}
                                readOnly={true}
                            />
                        </Tab>
                    </Tabs>
                }
            </Card.Body>
        </Card>
    )
}

export default withTranslation()(DetalleCitaAnexos2)